"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = void 0;
/**
 * 当前浏览器是否为移动端浏览器
 */
exports.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
